// Import the functions you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your friend's Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyAUvckRoZDtwLn1aDdvvN8porUockj2tFE",
    authDomain: "clipboard-online-1b729.firebaseapp.com",
    projectId: "clipboard-online-1b729",
    storageBucket: "clipboard-online-1b729.firebasestorage.app",
    messagingSenderId: "951528297598",
    appId: "1:951528297598:web:c59eae12938e9683f4342f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore database
export const db = getFirestore(app);
